import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface Entity {
  name: string;
  type: string;
  [key: string]: string | number | boolean | null | undefined;
}

export type EntityMap = Record<string, Entity>;

/**
 * Hook for fetching entities by their IDs
 * Used to retrieve data for entities referenced in metadata evidence
 */
export function useEntitiesByIds(entityIds: string[] = []) {
  return useQuery<EntityMap>({
    queryKey: ["entities", entityIds.sort().join(",")],
    queryFn: async () => {
      if (!entityIds.length) {
        return {};
      }

      const response = await api.get<{ entities: EntityMap }>(
        "datahub/entities/",
        {
          params: {
            ids: entityIds.join(","),
          },
        },
      );

      return response.entities || {};
    },
    enabled: entityIds.length > 0,
    // Keep the data for 5 minutes in cache
    staleTime: 5 * 60 * 1000,
  });
}
